import DJIDock3Matrice4T from '@/models/dji/dock3-matrice4t';
import DJIPilot2Mavic3E from '@/models/dji/pilot2-mavic3e';
import IoTM1Tracker from '@/models/iot/m1-tracker';
import MavArduAD3000 from '@/models/mavlink/ardupilot-ad3000';
import MavArduBoat from '@/models/mavlink/ardupilot-boat';
import MavArduCopter from '@/models/mavlink/ardupilot-copter';
import MavArduFW from '@/models/mavlink/ardupilot-fw';
import MavArduVTOL from '@/models/mavlink/ardupilot-vtol';
import MavPX4Copter from '@/models/mavlink/px4-copter';
import MavPX4Moonboat from '@/models/mavlink/px4-moonboat';
import MavPX4Rover from '@/models/mavlink/px4-rover';
import MavPX4Sheco from '@/models/mavlink/px4-sheco';
import MavPX4USV10 from '@/models/mavlink/px4-usv10';

const MODELS = {
  // DJI Dock3 Matrice 4T
  'd058a2af-1f6c-4edc-a4ff-0937a1eec34e': DJIDock3Matrice4T,
  // DJI Pilot2 Mavic 3E
  'c4004052-f68b-4af3-b75b-1a2dbe7691c9': DJIPilot2Mavic3E,
  // IoT M1 Tracker
  '3da2a623-9b10-45e6-be97-79d68be23339': IoTM1Tracker,
  // MavLink ArduPilot AD3000
  '529165b3-1f76-4dbd-9e5b-cb4005fd62dd': MavArduAD3000,
  // MavLink ArduPilot Boat
  '5f31c1f1-40ac-4677-8d8f-6f8ce75e667e': MavArduBoat,
  // MavLink ArduPilot Copter
  '0ae6489b-7fd4-4d9d-8b47-a8c6c7e669ca': MavArduCopter,
  // MavLink ArduPilot Fixed-wing
  '1a90a54a-e98c-4b26-89db-8f7b94fc065c': MavArduFW,
  // MavLink ArduPilot VTOL
  '85570cb9-64ee-46b8-b612-d8b07813d5ef': MavArduVTOL,
  // MavLink PX4 Copter
  'b5e665d7-dab4-41f0-84ca-df565269a256': MavPX4Copter,
  // MavLink PX4 Moonboat
  '04460d4f-7139-4a4f-9971-921d7a05e764': MavPX4Moonboat,
  // MavLink PX4 Rover
  '01ae244b-e6f9-49f6-a0e4-e57603893661': MavPX4Rover,
  // MavLink PX4 Sheco
  'd212a420-d77f-4b32-baf2-0e5095393037': MavPX4Sheco,
  // MavLink PX4 USV10
  '20c544f2-84a8-4569-94ef-35a423af6298': MavPX4USV10,
};

export default MODELS;
